module.exports = __webpack_public_path__ + "static/media/dong-logo.67e427bb.svg";